import { useEffect, useId } from 'react';

import { useAppShellActions } from '@/data/context/AppShellContext';
import { BreadcrumbItem } from '@/data/hook/useDynamicBreadcrumbItems';

export default function useShellBreadcrumbs(items?: BreadcrumbItem[]) {
  const ownerId = useId();
  const { setBreadcrumbsTarget } = useAppShellActions();

  useEffect(() => {
    if (!items) return;

    setBreadcrumbsTarget({ ownerId, items });

    return () =>
      setBreadcrumbsTarget(current =>
        current?.ownerId === ownerId ? undefined : current,
      );
  }, [setBreadcrumbsTarget, ownerId, items]);
}
